<template>
  <div class="rules" ref="section">
    <navTitle
      title="新闻资讯"
      class="op0"
      :class="getAnimationClass('section', 'animate__fadeInUp')"
    ></navTitle>
    <div class="w1200 mt66 content">
      <div
        class="left tc"
        :class="getAnimationClass('section', 'animate__fadeInLeft')"
      >
        <!-- <img
          src="@/assets/images/news/car2.png"
          width="100%"
          height="100%"
          alt=""
        /> -->
        <div @mouseenter="stopAutoplay" @mouseleave="startAutoplay">
          <swiper :options="swiperOption" ref="mySwiper" style="height: 400px">
            <swiper-slide v-for="(item, index) in hotList" :key="index">
              <div
                :id="item.id"
                class="bgBanner"
                :style="{
                  backgroundImage: `url(${imgRules(
                    item.coverImageUrl,
                    require('@/assets/images/news/car2.png')
                  )})`,
                }"
              >
                <div class="img-text" :id="item.id">{{ item.infoTitle }}</div>
              </div>
            </swiper-slide>
          </swiper>
        </div>
      </div>
      <div
        class="right p1"
        :class="getAnimationClass('section', 'animate__fadeInRight')"
      >
        <ul>
          <li
            v-for="(item, index) in titleList"
            :class="{ active: active === index }"
            @click="changeSwiperNew(index)"
            :key="index"
          >
            {{ item }}
          </li>
        </ul>

        <div class="contList">
          <swiper :options="swiperNewOption" ref="newsSwiper">
            <swiper-slide v-for="(item, index) in newsList" :key="index">
              <div style="height: 280px">
                <div v-if="item.length !== 0">
                  <div
                    :title="t.infoTitle"
                    class="fs18 items"
                    @click="$goRouter('/news/details', { id: t.id })"
                    v-for="t in item"
                    :key="t.id"
                  >
                    {{ t.infoTitle }}
                  </div>
                </div>
                <div v-else class="cl7b tc" style="padding-top: 140px">
                  暂无数据
                </div>
              </div>
            </swiper-slide>
          </swiper>
        </div>
        <div>
          <div class="buts" @click="$goRouter('/news/list')">查看更多</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import navTitle from "@/components/navTitle/index.vue";
import { observers } from "@/mixins/observers";
import { getHotList, getInfo } from "@/api/news";
import { setImgPath, imgRules } from "@/utils/index";

export default {
  name: "news",
  mixins: [observers],
  components: { navTitle, SwiperSlide, Swiper },
  data() {
    return {
      newsList: {
        NEWS: [],
        POLICY: [],
        PROV_REQUIRE: [],
        APPLY_GUIDE: []
      },
      hotList: [],
      active: 0,

      titleList: ["行业资讯", "政策法规", "各省要求", "申请指南", "线路快讯"],
      codeList: ["NEWS", "POLICY", "PROV_REQUIRE", "APPLY_GUIDE", "FLASH_NEWS"], //POLICY政策 LAW-法规，STANDARD-标准
      swiperOption: {
        loop: true,
        // direction: "vertical",
        autoplay: {
          disableOnInteraction: false,
          delay: 5000,
        },
        on: {
          click: (even) => {
            this.$goRouter("/news/details", { id: even.target.id });
          },
          init() {
            this.slideToLoop(1, 0); // 确保从第一张开始
          },
        },
        preventClicks: false,
        preventClicksPropagation: false,
        touchStartPreventDefault: false, // 🔥 关键：允许默认事件
        touchReleaseOnEdges: true,
      },
      swiperNewOption: {
        // API
        loop: false,
        on: {
          slideChangeTransitionStart: () => {
            if (this.$refs.newsSwiper && this.$refs.newsSwiper.$swiper) {
              this.active = this.$refs.newsSwiper.$swiper.realIndex;
            }
          },
        },
      },
      list: {},
    };
  },
  mounted() {
    this.getHots();

    this.getInfoList("NEWS");
    this.getInfoList("POLICY");
    this.getInfoList("PROV_REQUIRE");
    this.getInfoList("APPLY_GUIDE");
    this.getInfoList("FLASH_NEWS");

  },
  methods: {
    changeSwiperNew(i) {
      this.active = i;
      this.$refs.newsSwiper.$swiper.slideTo(i);
    },
    async getHots() {
      const { data } = await getHotList({
        categoryCode: this.codeList[this.active],
        limit: 5,
      });
      this.hotList = data;
    },
    stopAutoplay() {
      const swiper = this.$refs.mySwiper.$swiper;
      if (swiper && swiper.autoplay) {
        swiper.autoplay.stop();
      }
    },
    startAutoplay() {
      const swiper = this.$refs.mySwiper.$swiper;
      if (swiper && swiper.autoplay) {
        swiper.autoplay.start();
      }
    },
    async getInfoList(code) {
      const { data } = await getInfo({
        categoryCode: code,
        limit: 5,
      });
      // this.$set(this.newsList, code, data);
      this.newsList[code] = data;
    },
    imgRules,
  },
};
</script>


<style scoped lang="less">
.bgBanner {
  background-size: cover;
  width: 100%;
  height: 400px;
  position: relative;
  cursor: pointer;
}
.rules {
  background: url("../../assets/images/news/banner4.png") center no-repeat;
  background-size: cover;
  width: 100%;
  height: 684px;
  min-height: 680px;
  padding-top: 66px;

  .buts {
    width: 156px;
    height: 46px;
    background: #0fb1c0;
    border-radius: 2px;
    color: #ffffff;
    line-height: 46px;
    text-align: center;
    position: absolute;
    bottom: 0;
    right: 0;
    cursor: pointer;
    font-size: 18px;
  }
  .content {
    height: 480px;
    display: flex;
    background: rgba(255, 255, 255, 0.81);
    padding: 40px 30px;
    .left {
      width: 525px;
      height: 400px;
      position: relative;
      .titles {
        text-align: left;
        padding: 0 10px;
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        font-size: 16px;
        height: 54px;
        line-height: 54px;
        background: rgba(30, 51, 94, 0.8);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    .right {
      width: 608px;
      padding-left: 32px;
      ul {
        display: flex;
        border-bottom: 1px solid rgba(15, 177, 192, 1);
        justify-content: space-between;

        li {
          text-align: center;
          width: 33.333%;
          padding: 10px 0;
          color: rgba(15, 177, 192, 1);
          cursor: pointer;
          font-size: 24px;
          &:hover {
            .active;
          }
        }

        .active {
          border-bottom: 3px solid rgba(15, 177, 192, 1);
        }
      }
      .contList {
        padding: 12px 0 0 20px;

        .items {
          border-bottom: 1px solid rgba(240, 242, 246, 1);
          padding: 11px 0;
          position: relative;
          cursor: pointer;
          padding-left: 20px;
          max-width: 100%;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          // &:nth-child(n + 3) {
          //   &:after {
          //     background: rgba(204, 215, 226, 1);
          //   }
          // }
          &:after {
            content: "";
            display: block;
            width: 8px;
            height: 8px;
            border-radius: 100%;
            background: rgba(15, 177, 192, 1);
            position: absolute;
            top: 21px;
            left: 0;
          }
        }
      }
    }
  }
}

.img-text {
  background: #435272;
  width: 100%;
  height: 54px;
  line-height: 54px;
  padding-left: 20px;
  position: absolute;
  left: 0;
  bottom: 0;
  color: #ffffff;
  font-size: 18px;
  text-align: left;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  padding-right: 10px;
}
</style>